import { render } from "./TrainingCalendar.vue?vue&type=template&id=05a5cacd&scoped=true"
import script from "./TrainingCalendar.vue?vue&type=script&lang=js"
export * from "./TrainingCalendar.vue?vue&type=script&lang=js"

import "./TrainingCalendar.vue?vue&type=style&index=0&id=05a5cacd&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a5cacd"]])

export default __exports__